import { values } from "lodash";
import { getHeaderSimple, getHeaderMultipart } from "./utils";
import axios from 'axios';

export const getItems = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}foundation/`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
};

export const searchItem = async (search) => {

    const response = await fetch(`${process.env.REACT_APP_API_URL}foundation/search/${search}`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.data) {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
}

export const addItem = async (newObject) => {

    const formData = new FormData();
    formData.append("name", newObject?.name);
    formData.append("city", newObject?.city);
    formData.append("typeOfFoundation", newObject?.typeOfFoundation);
    formData.append("logo", newObject?.logo)

    return axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}foundation/`,
        data: formData,
        headers: getHeaderMultipart(),
    });
}

export const updateItem = async (newObject, id) => {

    const formData = new FormData();
    formData.append("name", newObject?.name);
    formData.append("city", newObject?.city);
    formData.append("typeOfFoundation", newObject?.typeOfFoundation);
    formData.append("status", newObject?.status);
    if (newObject.logo !== '' && !newObject.logo.toString().includes('https://res.cloudinary.com'))
        formData.append("logo", newObject.logo);

    const result = await axios({
        method: "put",
        url: `${process.env.REACT_APP_API_URL}foundation/${id}`,
        data: formData,
        headers: getHeaderMultipart(),
    });

    if (result.data?.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
        };
    } else {
        return {
            status: "Error",
            message: result.data?.message ?? "No se pudo editar el registro",
        };
    }
}

export const getStatus = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}generalstatus/`, {
        method: "GET",
        headers: getHeaderSimple(),
    });
    const json = await response.json();

    if (json.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
            content: json.data,
        };
    } else {
        return {
            status: "Error",
            message: json.content ?? "Error de conexión"
        }
    }
}

export const dropOne = async (id) => {
    console.log("odrepo",id)
    const result = await axios({
        url: `${process.env.REACT_APP_API_URL}foundation/${id}`,
        method: "delete",
        headers: getHeaderSimple(),
    });

    console.log(result)

    if (result.data?.message === "Ok") {
        return {
            status: "Ok",
            message: "Ok",
        };
    } else {
        return {
            status: "Error",
            message: result.data?.message ?? "No se pudo eliminar el estudiante",
        };
    }
}
